
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/blog/[id]",
      function () {
        return require("private-next-pages/learn/blog/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/blog/[id]"])
      });
    }
  